import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Button, Form, Icon } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  // console.log(props.elemento)
  return (
    <option style={props.styles.input}>{props.elemento.numCoti}</option>
  )
};

const ListaSol = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="numCoti" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar solicitud de compra...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

//Lista de cotizaciones
const DetalleNo = ({elemento, handleClickGesEgr, argsDocum}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProveed}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProducto}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadCoti}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadAprob}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
      {/* <td className='right aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valorUniCoti}</td> */}
      <td className='right aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{new Intl.NumberFormat('de-DE').format(elemento.valorUniCoti)}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcDcto?elemento.porcDcto:0}</td>      
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcIVA}</td>      
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioCreate}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaCreate.substr(0, 10)}</td>

      <td className='center aligned' style={{padding: '0.2em'}}>
        <div className="ui mini vertical yellow animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.2em', paddingRight: '0.1em'}}>
          <div className="hidden content" onClick={(ev)=>handleClickGesEgr(ev, elemento, "Agregar", argsDocum)}>Agregar</div>
          <div className="visible content">
            <i className="large thumbs up icon" style={{padding: '0.2em'}} onClick={(ev)=>handleClickGesEgr(ev, elemento, "Agregar")}></i>
          </div>
        </div>
      </td>
    </tr>
  )
};

const ListaNo = ({list, handleClickGesEgr, argsDocum}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleNo elemento={elemento} handleClickGesEgr={handleClickGesEgr} argsDocum={argsDocum}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const DetalleSi = ({elemento, handleClickGesEgr}) => {
  let color=elemento.color
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProveed}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProducto}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadAprob}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{new Intl.NumberFormat('de-DE').format(elemento.valorUniCoti)}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcDcto}</td>      
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcIVA}</td>      
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioCreate}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaCreate.substr(0, 10)}</td>
      
      <td className='center aligned' style={{padding: '0.2em'}}>
        <div className="ui mini vertical red animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.2em', paddingRight: '0.1em'}}>
          <div className="hidden content" onClick={(ev)=>handleClickGesEgr(ev, elemento, "Quitar")}>Quitar</div>
          <div className="visible content">
            <i className="large thumbs down icon" style={{padding: '0.2em'}} onClick={(ev)=>handleClickGesEgr(ev, elemento, "Quitar")}></i>
          </div>
        </div>
      </td>
    </tr>
  )
};

const ListaSi = ({list, handleClickGesEgr}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleSi elemento={elemento} handleClickGesEgr={handleClickGesEgr}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos informe

class AdminCotizacionSelecc2 extends React.Component {
  state={argsDocum: {numCoti: "Seleccionar solicitud de compra..."}, list: [], list1: [],
          permiteUpdate: true, confirmaAct: false, open: false, 
          argsQuery: `{"$unwind": "$itemsCoti"},
          {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, fechaCreate: 1, numCoti: 1, 
          usuarioCreate: 1, descrProveed: 1, numSolic: 1, tipo: 1, tipoCoti: 1, estadoCoti: 1,
            cantidadCoti: '$itemsCoti.cantidadCoti', cantidadAprob: '$itemsCoti.cantidadAprob', 
            descrProducto: '$itemsCoti.descrProducto', descrUnidad: '$itemsCoti.descrUnidad', numProductoCoti: '$itemsCoti.numProductoCoti', 
            valorUniCoti: '$itemsCoti.valorUniCoti', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto'}},   
            {$match: {cantidadAprob: 0}}, 
            {$sort: {numSolic: 1, descrProveed: 1}}`,
          argsQuery1: `{"$unwind": "$itemsCoti"},
            {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, fechaCreate: 1, numCoti: 1, 
            usuarioCreate: 1, descrProveed: 1, numSolic: 1, tipo: 1, tipoCoti: 1, estadoCoti: 1,
              cantidadCoti: '$itemsCoti.cantidadCoti',  cantidadAprob: '$itemsCoti.cantidadAprob', 
              descrProducto: '$itemsCoti.descrProducto', descrUnidad: '$itemsCoti.descrUnidad', numProductoCoti: '$itemsCoti.numProductoCoti', 
              valorUniCoti: '$itemsCoti.valorUniCoti', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto'}},   
              {$match: {cantidadAprob: {$gt: 0}}}, 
              {$sort: {numSolic: 1, descrProveed: 1}}`,  
        }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev) => {
    const argsDocum = this.state.argsDocum
    let argsBuscar="tipoCoti: 'Proveedor', estadoCoti: 'Creada', tipo: 'Cotización'"
    if(ev.target.name==="numCoti"){
      argsBuscar += `, 'numSolic': '${ev.target.value}'`
      argsDocum[ev.target.name] = ev.target.value
    }
    if(this.state.argsQuery){
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      console.log(argsBuscarPl)
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarPl)
      let list = []
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        list = await data.allCotizacionRtes
      }
      // if(list.length>0){
        this.setState({list});
      // }
    }
    if(this.state.argsQuery1){
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarPl)
      let list1 = []
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        list1 = await data.allCotizacionRtes
      }
      // if(list1.length>0){
        this.setState({list1});
      // }
    }
    this.setState({argsDocum});
  }

  handleClickGesEgr = async (ev, elemento, accion, args)=>{
    document.body.style.cursor = 'wait'

    let cantAprob = 0
    if(accion==="Agregar"){
      cantAprob = parseInt(elemento.cantidadCoti)
    }
    let tipoAc=''
    if(elemento.numProductoCoti && elemento.numProductoCoti>0){
      tipoAc = 'EditarItem2ID'
    }else{
      tipoAc = 'EditarItem2'
    }
    const argsUpd = {
      numCoti: elemento.numCoti,
      numProductoCoti: elemento.numProductoCoti?elemento.numProductoCoti:0,
      cantidadAprob: cantAprob,
      descrProducto: elemento.descrProducto,
      tipoAct: 'EditarItem2'
    }
console.log(accion, argsUpd)
    const response = await this.props.editCotizacion({
      variables: argsUpd
    });
    const {errors, success} = response.data.editCotizacion;

    const argsDocum = this.state.argsDocum
    let argsBuscar="tipoCoti: 'Proveedor', estadoCoti: 'Creada', tipo: 'Cotización'"
    argsBuscar += `, 'numSolic': '${argsDocum.numCoti}'`
    if(this.state.argsQuery){
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarPl)
      let list = []
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        list = await data.allCotizacionRtes
      }
      // if(list.length>0){
        this.setState({list});
      // }
    }
    if(this.state.argsQuery1){
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarPl)
      let list1 = []
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        list1 = await data.allCotizacionRtes
      }
      // if(list1.length>0){
        this.setState({list1});
      // }
    }

    document.body.style.cursor = 'default'
  }

  handleSubmit = async (ev, list1)=>{
    if(list1.length>0){
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaRta = fechaHoraHoy
      let usuarioRta = localStorage.getItem('userLogin')
      document.body.style.cursor = 'wait'
      let list = list1

      let numOrdenCompra = 0
      let estadoOC = 'Creada' 
      let rta = 'Cerrada'
      let numCotiAnt = ''
      for(let ii=0; ii<list.length; ii++){

        if(numCotiAnt==='' || list[ii].numCoti!==numCotiAnt){
          numOrdenCompra = await this.nextVal('ordenCompraPro')

          const argsUpd = {
            numCoti: list[ii].numCoti,
            estadoCoti: rta,
            estadoOC: estadoOC,
            fechaRta: fechaRta,
            usuarioRta: usuarioRta,
            numOrdenCompra: numOrdenCompra,
            tipoAct: 'EditarRta2'
          }
          response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
    
          if (!success){
            this.setState({errorAdd: errors})
          }
        }
        numCotiAnt = list[ii].numCoti
        if(ii===list.length-1){
          const argsUpd = {
            numCoti: list[ii].numSolic,
            estadoCoti: rta,
            fechaEnvio: fechaRta,
            usuarioEnvio: usuarioRta,
            tipoAct: 'EditarEstado'
          }
          response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
    
          if (!success){
            this.setState({errorAdd: errors})
          }

          const argsUpd1 = {
            numCoti: list[ii].numSolic,
            estadoCoti: rta,
            fechaEnvio: fechaRta,
            usuarioEnvio: usuarioRta,
            tipoAct: 'CerrarCoti'
          }
          response = await this.props.editCotizacion({
            variables: argsUpd1
          });
          const {errors1, success1} = response.data.editCotizacion;
    
          if (!success1){
            this.setState({errorAdd: errors1})
          }
        }  
      }
      this.props.allCotizacionProRtes3.refetch()
      this.props.allCotizacionRtes.refetch()
      document.body.style.cursor = 'default'

      alert("!! Orden de compra generada !!")

      document.body.style.cursor = 'default'
      this.setState({open: false, confirmaAct: false})
    }else{
      alert("!! No hay items seleccionados !!")
    }
  }

  handleReversar = async (ev, numCoti)=>{
    if(numCoti){
      document.body.style.cursor = 'wait'

      const argsUpd = {
        numCoti: numCoti,
        estadoCoti: 'Creada',
        tipoAct: 'ReversarSolic'
      }

      let response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        let argsBuscarIt2 = {}
        argsBuscarIt2 = {tipoqry: `[{$match: {'tipo': 'Cotización', 'numSolic': '${numCoti}'}},
        {$project: {_id: 1, numCoti: 1}}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarIt2)
        if(data.allCotizacionRtes.length>0){
          for(let i=0; i<data.allCotizacionRtes.length; i++){
            const argsDel = {
              _id: data.allCotizacionRtes[i]._id
            }
            await this.props.deleteCotizacion({
              variables: argsDel
            });
          }
        }
        // this.state.lista=[]
        // this.state.lista4=[]
        // this.props.allCotizacionRtes3.refetch()
        document.body.style.cursor = 'default'

        alert("!! Estado reversado !!")
      }
    }else{
      alert("!! Por favor seleccione una solicitud !!")
    }
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, permiteUpdate, confirmaAct, open, list, list1} = this.state;
console.log(this.state)

    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "Generar orden de compra"
    let mensaje7 = "REVERSAR " 
    if(argsDocum.numCoti){
      mensaje7 += argsDocum.numCoti
    }
    let imgIcon = "images/documento_32.png"

    let listSi = [], listNo = [], list2 = []
    if(this.props.allCotizacionProRtes3.allCotizacionRtes){list2 = this.props.allCotizacionProRtes3.allCotizacionRtes}

    if(list1){listSi = list1}
    if(list){listNo = list}

    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list1):()=>{}}>
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '50%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaSol styles={this.props.styles} list={list2} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                {argsDocum.numCoti &&
                <div className="column" style={{width: '25%'}}>
                  <Button id="reversar" name="reversar" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleReversar(ev, argsDocum.numCoti)} fluid>
                    {mensaje7}
                  </Button>                 
                </div>
              }
                <div className="column" style={{width: '25%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>

            {/* <hr></hr> */}

            <div>
              <div style={{height: '20em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Cotización</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Proveedor</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Cant. coti.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Cant. aprob.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Valor Und</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Descuento</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% IVA</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Creó</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Seleccionar</th>
                    </tr>
                  </thead>
                  <ListaNo list={listNo} handleClickGesEgr={this.handleClickGesEgr} argsDocum={argsDocum}/>
                </table>
                <p></p>
              </div>
            </div>

            <hr></hr>

            <div>
              <div style={{height: '15em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Cotización</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Proveedor</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Cant. coti.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Cant. aprob.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Valor Und</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Dcto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% IVA</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Creó</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Quitar</th>
                    </tr>
                  </thead>
                  <ListaSi list={listSi} handleClickGesEgr={this.handleClickGesEgr}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes3',
  options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Aprobada', tipo: 'Solicitud'}}]`}}}}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {numCoti: 'Seleccionar solicitud de compra...'}}]`}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  graphql(queries.mutation.deleteCotizacion, {name:'deleteCotizacion'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(AdminCotizacionSelecc2)
